export const SHARE_OPTIONS: any[] = [
  {
    label: 'can view',
    value: 'view'
  },
  {
    label: 'can edit',
    value: 'edit'
  }
];
